import React, {Component} from 'react';
import {connect} from "react-redux";
import {Table, Badge} from 'react-bootstrap';
import {loadState} from "../../LocalStore/localStorage";
import {
    accessLogSend,
    getLiveSchedule,
    getOneToManySchedule,
    getOneToOneSchedule, instructorPresent
} from "../../redux/actions/instructor";
import {changeLiveStatus} from "../../redux/actions/auth";
import {Link} from "react-router-dom";
import {home, urlUpdate, scheduleType} from "../../utils/routes";
import LeftMenu from './LeftMenu';
import oneToOne from "../../assets/static/svg/one_to_one.svg";
import grouplearning from "../../assets/static/svg/Group_learning.svg";
import {ReactSVG} from 'react-svg';
import moment from "moment";
import mobileNumberHide from "../../redux/helper/mobileNumberHide";
import Coundown from "../common/Coundown";


class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userInfo: loadState('userInfo')
        }
    }

    componentDidMount = async () => {
        window.scrollTo(0, 0);
        const {id, instructor_id, first_name, last_name, mobile_number} = this.state.userInfo;
        await this.props.dispatch(accessLogSend(`${id}|#|${instructor_id}|#|${first_name} ${last_name}|#|${mobile_number}`, 'Home'));
        await this.props.dispatch(getLiveSchedule(this.state.userInfo.id));
        await this.props.dispatch(getOneToManySchedule(this.state.userInfo.id));
    };

    changeLiveStatus = async (isLive, id, instructor_id, tuition_classes_id, tuition_config_id, class_num) => {
        await this.props.dispatch(changeLiveStatus(this.state.userInfo.id, !isLive, id));
        await this.props.dispatch(getOneToManySchedule(this.state.userInfo.id))
        if (!isLive)
            await this.props.dispatch(instructorPresent(instructor_id, tuition_classes_id, tuition_config_id, class_num));
    };

    instructorPresent = async (instructor_id, student_id, tuition_classes_id, tuition_config_id, class_num) => {
        await this.props.dispatch(instructorPresent(instructor_id, tuition_classes_id, tuition_config_id, class_num));
        await window.open(`https://test.iqra-live.com/?room=${instructor_id}-${student_id}`, "mywindow", "menubar=1,resizable=1,width=1080,height=600")
    };

    render() {
        const items = this.props.InstructorLiveList;
        const oneToMany = this.props.oneToMany;
        const {userInfo} = this.state;
        return (
            <div className="mainBody">
                <div className="container">
                    <div className="row">
                        <div className="col-12 rightContent">
                            <div className="rightBodyContent">
                                <h3 className="secTitle text-center">Recent Tuitions</h3> <br/> <br/>

                                <div className="tutionBody">
                                    <div className="row justify-content-center">
                                        {items.data &&
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-12 LiveInstactorItem">
                                            <div className="LiveInstactorSingleItem">
                                                <div className="itemImg">
                                                    <ReactSVG src={oneToOne}/>
                                                </div>
                                                <div className="liveRight">

                                                </div>
                                                <div className="cont">
                                                    <h4 className="teacherName">One to One</h4>
                                                    <h5 className="text-danger">{items.data.message}</h5>
                                                </div>
                                                <div className="btnGroup d-flex justify-content-between">
                                                    <div className="d-flex">
                                                    </div>
                                                    <div className="">
                                                    </div>

                                                </div>
                                            </div>
                                        </div>}
                                        {items && items.length > 0 && items.map((item, index) =>
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-12 LiveInstactorItem"
                                                 key={index}>
                                                <div className="LiveInstactorSingleItem">
                                                    <div className="itemImg">
                                                        <ReactSVG src={oneToOne}/>
                                                    </div>
                                                    <div className="liveRight">
                                                        <Coundown countdown={item.countdown}/>
                                                        <div className="dateTime">
                                                            <p className="LiveDate"><Badge
                                                                variant="warning">{item.next_class_date_time}</Badge>
                                                            </p>
                                                            <p className="LiveDate"><Badge
                                                                variant="primary">{moment(item.start_date).format('LL')}</Badge>
                                                            </p>
                                                            <p className="LiveDate"><Badge
                                                                variant="success">{item.start_time}
                                                                ---
                                                                {item.end_time} </Badge></p>
                                                        </div>
                                                    </div>
                                                    <div className="cont">
                                                        <h4 className="teacherName">One to One</h4>
                                                        <p>{item.tuition_en}</p>
                                                    </div>
                                                    <div className="btnGroup d-flex justify-content-between">
                                                        <div className="d-flex">

                                                        <span className="btn"
                                                              onClick={() => this.instructorPresent(userInfo.instructor_id, item.student_id, 0, item.id, 1)}>
                                                            Go To Live
                                                        </span>


                                                            <span className="btn">Module {item.ordering_number}</span>
                                                        </div>
                                                        <div className="">

                                                            <div className="enrolInfoWrap"><span
                                                                className="btn">Enrol Info</span>
                                                                <div className="info">
                                                                    <p>{item.first_name} {item.last_name}</p>
                                                                    <p>{item.student_msisdn ? mobileNumberHide(item.student_msisdn) : ''}</p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {oneToMany && oneToMany.length > 0 && oneToMany.slice(0, 1).map((item, index) =>
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-12 LiveInstactorItem"
                                                 key={index}>
                                                <div className="LiveInstactorSingleItem">
                                                    <div className="itemImg oneToMany">
                                                        <ReactSVG src={grouplearning}/>
                                                    </div>
                                                    <div className="liveRight">
                                                        {!item.is_live &&
                                                        <Coundown countdown={item.countdown}/>
                                                        }
                                                        {item.is_live &&
                                                        <div className="liveNow">
                                                            <div className="live_icon">
                                                                <div className="inner"></div>
                                                            </div>
                                                            <p className="live">LIVE</p>
                                                        </div>
                                                        }
                                                        <div className="dateTime">
                                                            <p className="LiveDate"><Badge
                                                                variant="primary">{moment(item.start_date).format('LL')}</Badge>
                                                            </p>
                                                            <p className="LiveDate"><Badge
                                                                variant="success">{item.start_time}
                                                                ---
                                                                {item.end_time}</Badge></p>
                                                        </div>
                                                    </div>
                                                    <div className="cont">
                                                        <h4 className="teacherName">One to Many</h4>
                                                        <p>{item.tuition_en}</p>
                                                    </div>
                                                    <div className="btnGroup">
                                                        {/*<span class="btn">Module 1</span>*/}
                                                        <label className="switch">
                                                            <input type="checkbox"
                                                                   onChange={() => this.changeLiveStatus(item.is_live, item.id, userInfo.instructor_id, item.tuition_id, item.id, 1)}
                                                                   checked={item.is_live}/>
                                                            <span className="slider round"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    InstructorLiveList: state.InstructorLiveList,
    liveStatusChange: state.liveStatusChange,
    oneToOne: state.oneToOneReducer,
    oneToMany: state.oneToManyReducer
});

export default connect(mapStateToProps)(Home);
